<template>
  <div>
    <router-link :to="{ name: 'Index' }">
      <img class="logo" src="@/assets/complete-logo.png" alt="Logo">
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'CompleteLogo'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.logo {
  height: 32px;
  cursor: pointer;
}
</style>
